import { Translation } from '@shared/types/translation';

export const TECHNICIAN_LABELS = {
  VIEW_CALENDAR_BUTTON: {
    english: 'View Calendar',
    polish: 'Zobacz kalendarz',
  },
  PRIVILEGES_SELECT_ALL: {
    english: 'Select All',
    polish: 'Zaznacz wszystko',
  },
  MODULE_MANAGE_TASKS: {
    english: 'Manage Assigned Tasks',
    polish: 'Zarządzaj przypisanymi zadaniami',
  },
  PRIV_TASK_LIST: {
    english: 'List of Assigned Tasks',
    polish: 'Lista przypisanych zadań',
  },
  PRIV_TASK_VIEW: {
    english: 'View Assigned Task Details',
    polish: 'Wyświetl szczegóły przypisanego zadania',
  },
  PRIV_TASK_UPDATE_STATUS: {
    english: 'Update Task Status',
    polish: 'Zaktualizuj status zadania',
  },
  PRIV_TASK_FILL_FORM: {
    english: 'Fill Task Form',
    polish: 'Wypełnij formularz zadania',
  },
  PRIV_TASK_ACCEPT_REJECT: {
    english: 'Accept/Reject Task',
    polish: 'Zaakceptuj/Odrzuć zadanie',
  },
  MODULE_CERTIFICATES: {
    english: 'Certificate Management',
    polish: 'Zarządzanie certyfikatami',
  },
  PRIV_CERT_LIST: {
    english: 'List of Certificates',
    polish: 'Lista certyfikatów',
  },
  // Sheet gives one combined "View and Download Certificate" item, but the
  // code has this split into two separate privileges — split the Polish
  // translation to match (confirmed with user).
  PRIV_CERT_VIEW: {
    english: 'View Certificate',
    polish: 'Wyświetl certyfikat',
  },
  PRIV_CERT_DOWNLOAD: {
    english: 'Download Certificate',
    polish: 'Pobierz certyfikat',
  },
  MODULE_INVOICES: {
    english: 'Invoice Management',
    polish: 'Zarządzanie fakturami',
  },
  PRIV_INVOICE_LIST: {
    english: 'List of Invoices',
    polish: 'Lista faktur',
  },
  PRIV_INVOICE_VIEW: {
    english: 'View Invoice Details',
    polish: 'Wyświetl szczegóły faktury',
  },
  PRIV_INVOICE_DOWNLOAD: {
    english: 'Download Invoice',
    polish: 'Pobierz fakturę',
  },
  VIEW_CALENDAR_PERMISSION_DENIED: {
    english: 'You do not have permission to view this Service Request.',
    polish: 'Nie masz uprawnień do wyświetlenia tego zgłoszenia serwisowego.',
  },
  SCHEDULE_LOADING: {
    english: 'Loading technician calendar',
    polish: 'Ładowanie kalendarza technika',
  },
  // TODO: real Polish copy pending from design — placeholder mirrors English.
  SCHEDULE_DATA_VIEW_ALL: {
    english: 'All except rejected',
    polish: 'All except rejected',
  },
  SCHEDULE_DATA_VIEW_REJECTED: {
    english: 'Rejected',
    polish: 'Odrzucone',
  },
  SCHEDULE_DATA_VIEW_GROUP_ARIA: {
    english: 'Requests view',
    polish: 'Widok zgłoszeń',
  },
  SCHEDULE_SR_MODAL_TITLE: {
    english: 'Service Request',
    polish: 'Zgłoszenie Serwisowe',
  },
  SCHEDULE_SR_MODAL_VIEWING: {
    english: 'Viewing',
    polish: 'Viewing',
  },
  SCHEDULE_SR_MODAL_OF: {
    english: 'of',
    polish: 'z',
  },
  // Generic actions — not modal-specific, reusable by any future dialog in this epic.
  CLOSE: {
    english: 'Close',
    polish: 'Zamknij',
  },
  PREVIOUS: {
    english: 'Previous',
    polish: 'Poprzedni',
  },
  NEXT: {
    english: 'Next',
    polish: 'Następny',
  },
} as const satisfies Record<string, Translation>;
